import { render, staticRenderFns } from "./NavbarItem.vue?vue&type=template&id=bd3c4bea&scoped=true"
import script from "./NavbarItem.vue?vue&type=script&lang=js"
export * from "./NavbarItem.vue?vue&type=script&lang=js"
import style0 from "./NavbarItem.vue?vue&type=style&index=0&id=bd3c4bea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd3c4bea",
  null
  
)

export default component.exports